import PasswordInput from '../components/PasswordInput';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const KullanicilarPage = () => {
  const [kullanicilar, setKullanicilar] = useState([]);
  const [roller, setRoller] = useState([]);
  const [form, setForm] = useState({ ad: '', soyad: '', email: '', sifre: '', rol: 'personel' });
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState(null);
  const [formAcik, setFormAcik] = useState(false);
  const [rolPaneli, setRolPaneli] = useState(null);
  const [sifrePanel, setSifrePanel] = useState(null);
  const [yeniSifre, setYeniSifre] = useState('');
  const [arama, setArama] = useState('');

  const yukle = () => {
    axios.get('/api/admin/kullanicilar').then(r => setKullanicilar(r.data)).catch(console.error);
    axios.get('/api/admin/roller').then(r => setRoller(r.data)).catch(console.error);
  };
  useEffect(() => { yukle(); }, []);

  const handleSubmit = async e => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/admin/kullanicilar', form);
      setSonuc({ tip: 'basari', mesaj: 'Kullanici olusturuldu.' });
      setForm({ ad: '', soyad: '', email: '', sifre: '', rol: 'personel' });
      setFormAcik(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const aktifDegistir = async (id, aktif) => {
    try { await axios.patch('/api/admin/kullanicilar/' + id + '/aktif', { aktif: !aktif }); yukle(); }
    catch { setSonuc({ tip: 'hata', mesaj: 'Durum guncellenemedi.' }); }
  };

  const rolDegistir = async (id, yeniRol) => {
    try {
      await axios.patch('/api/admin/kullanicilar/' + id + '/rol', { rol: yeniRol });
      setSonuc({ tip: 'basari', mesaj: 'Rol guncellendi.' });
      setRolPaneli(null); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
  };

  const adminSifreSifirla = async (id) => {
    if (!yeniSifre || yeniSifre.length < 6) { setSonuc({ tip: 'hata', mesaj: 'Sifre en az 6 karakter olmali.' }); return; }
    try {
      await axios.post('/api/sifre/admin-sifirla', { kullanici_id: id, tur: 'personel', yeni_sifre: yeniSifre });
      setSonuc({ tip: 'basari', mesaj: 'Sifre guncellendi.' });
      setSifrePanel(null); setYeniSifre('');
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
  };

  const kullaniciSil = async (id, adSoyad) => {
    if (!window.confirm(adSoyad + ' adlı kullanıcıyı silmek istediginize emin misiniz? Bu işlem geri alınamaz.')) return;
    try {
      await axios.delete('/api/admin/kullanicilar/' + id);
      setSonuc({ tip: 'basari', mesaj: adSoyad + ' silindi.' });
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Silinemedi.' }); }
  };

  const fmt = t => t ? new Date(t).toLocaleDateString('tr-TR') : '-';
  const filtrelenmis = kullanicilar.filter(k =>
    (k.ad + ' ' + k.soyad + ' ' + k.email + ' ' + k.rol).toLowerCase().includes(arama.toLowerCase())
  );
  const rolBaslik = (rol) => {
    const r = roller.find(x => x.anahtar === rol);
    return r ? r.baslik : rol;
  };

  const sifrePaneliAc = (id) => {
    setSifrePanel(prev => prev === id ? null : id);
    setRolPaneli(null);
    setYeniSifre('');
  };

  const rolPaneliAc = (id) => {
    setRolPaneli(prev => prev === id ? null : id);
    setSifrePanel(null);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Kullanicilar</h2>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Sistem kullanicilarini yonetin.</p>
        </div>
        <button type="button" className="btn btn-primary" onClick={() => setFormAcik(!formAcik)}>{formAcik ? 'Iptal' : '+ Yeni Kullanici'}</button>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {formAcik && (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header"><h2>Yeni Kullanici Ekle</h2></div>
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group"><label>Ad *</label><input type="text" value={form.ad} onChange={e => setForm({ ...form, ad: e.target.value })} required /></div>
              <div className="form-group"><label>Soyad *</label><input type="text" value={form.soyad} onChange={e => setForm({ ...form, soyad: e.target.value })} required /></div>
              <div className="form-group"><label>E-posta *</label><input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required /></div>
              <div className="form-group"><label>Sifre *</label><PasswordInput value={form.sifre} onChange={e => setForm({ ...form, sifre: e.target.value })} required minLength={6} /></div>
              <div className="form-group"><label>Rol *</label>
                <select value={form.rol} onChange={e => setForm({ ...form, rol: e.target.value })}>
                  {roller.map(r => <option key={r.anahtar} value={r.anahtar}>{r.baslik}</option>)}
                </select>
              </div>
            </div>
            <div style={{ marginTop: '1rem' }}>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Olusturuluyor...' : 'Kullanici Olustur'}</button>
            </div>
          </form>
        </div>
      )}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)' }}>
          <input type="text" placeholder="Isim, email, rol ara..." value={arama} onChange={e => setArama(e.target.value)} style={{ width: '100%', maxWidth: '360px' }} autoComplete="off" />
        </div>
        <div className="tablo-wrapper">
          <table>
            <thead>
              <tr><th>Kullanici</th><th>Rol</th><th>Kayit Tarihi</th><th>Durum</th><th>Islemler</th></tr>
            </thead>
            <tbody>
              {filtrelenmis.map(k => (
                <React.Fragment key={k.id}>
                  <tr>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div className="avatar" style={{ width: '28px', height: '28px', fontSize: '11px' }} data-harf={k.ad[0] || '?'}>{k.ad[0]}{k.soyad[0]}</div>
                        <div>
                          <div style={{ fontWeight: '500', fontSize: '14px' }}>{k.ad} {k.soyad}</div>
                          <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{k.email}</div>
                        </div>
                      </div>
                    </td>
                    <td><span className="badge badge-bekliyor">{rolBaslik(k.rol)}</span></td>
                    <td style={{ fontSize: '13px' }}>{fmt(k.olusturma_tarihi)}</td>
                    <td><span className={'badge ' + (k.aktif ? 'badge-tamamlandi' : 'badge-hata')}>{k.aktif ? 'Aktif' : 'Pasif'}</span></td>
                    <td>
                      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => rolPaneliAc(k.id)}>Rol Degistir</button>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => sifrePaneliAc(k.id)}>Sifre</button>
                        <button type="button" className={'btn btn-sm ' + (k.aktif ? 'btn-danger' : 'btn-secondary')} onClick={() => aktifDegistir(k.id, k.aktif)}>{k.aktif ? 'Pasif' : 'Aktif'}</button>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => kullaniciSil(k.id, k.ad + ' ' + k.soyad)}>Sil</button>
                      </div>
                    </td>
                  </tr>
                  {rolPaneli === k.id && (
                    <tr>
                      <td colSpan={5} style={{ background: 'var(--gri-50)', padding: '0.75rem 1.25rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Yeni rol:</span>
                          <select defaultValue={k.rol} onChange={e => rolDegistir(k.id, e.target.value)} style={{ fontSize: '13px', padding: '4px 8px' }}>
                            {roller.map(r => <option key={r.anahtar} value={r.anahtar}>{r.baslik}</option>)}
                          </select>
                          <button type="button" className="btn btn-secondary btn-sm" onClick={() => setRolPaneli(null)}>Iptal</button>
                        </div>
                      </td>
                    </tr>
                  )}
                  {sifrePanel === k.id && (
                    <tr>
                      <td colSpan={5} style={{ background: 'var(--gri-50)', padding: '0.75rem 1.25rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                         <PasswordInput value={yeniSifre} onChange={e => setYeniSifre(e.target.value)} placeholder="Yeni sifre (min 6 karakter)" style={{ fontSize: '13px', padding: '4px 8px', width: '240px' }} autoComplete="new-password" />
                          <button type="button" className="btn btn-primary btn-sm" onClick={() => adminSifreSifirla(k.id)}>Kaydet</button>
                          <button type="button" className="btn btn-secondary btn-sm" onClick={() => setSifrePanel(null)}>Iptal</button>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default KullanicilarPage;